import {Button, Card, Col, Form, Row} from "react-bootstrap";
import React, {useState} from "react";
import {RequireAuth} from "../../Components/Security/RequireAuth";
import {DefaultContainer} from "../Shared/DefaultContainer";
import {FormLabelRequiredAsterisk} from "../../Components/Form/FormLabelRequiredAsterisk";
import {useQuery} from "react-query";
import {revenueReport} from "../../Api/Query/Finance";
import {forceDownloadFromUrl} from "../../Services/File/FileDownloader";
import MonthSelector from "../Datetime/MonthSelector";
import YearSelector from "../Datetime/YearSelector";
import {Notificator} from "../../Services/Notificator/Notificator";

export const FinanceRevenueView: React.FC = () => {

    const defaultSearchFilters = {
        year: new Date().getFullYear(), // current year
        month: -1
    }
    const [searchFilters, setSearchFilters] = useState<{
        [key: string]: any
    }>(defaultSearchFilters)

    const reportQuery = useQuery({
        enabled: false,
        queryKey: ['financeRevenueReport'],
        queryFn: () => revenueReport(searchFilters),
        onSuccess: (response: any) => {
            const data = response?.data?._result ?? []
            const url = data?.url ?? ''

            if (url) {
                forceDownloadFromUrl(url)
            }else{
                Notificator.warning('No se encontraron datos para el mes y año seleccionados.')
            }
        }
    })

    return (
        <RequireAuth>
            <DefaultContainer>
                <Col id={"mainRequestList"}>
                    <Row>
                        <Col xs={12} className={""}>
                            <h1 className={"pb-lg-4"}>Rendimiento económico</h1>
                        </Col>
                    </Row>

                    <Row className={"mb-2"}>
                        <Card className={"px-0 mx-2 my-2"}>
                            <Card.Body>
                                <Row>
                                    <Col sm={4}>
                                        <Form.Group controlId={"queryFilter"}>
                                            <Form.Label>
                                                Mes
                                            </Form.Label>
                                            <MonthSelector
                                                onChange={(month: number) => setSearchFilters({
                                                    ...searchFilters, month: month
                                                })}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group controlId={"queryFilter"}>
                                            <Form.Label>
                                                Año&nbsp;<FormLabelRequiredAsterisk/>
                                            </Form.Label>
                                            <YearSelector
                                                onChange={(year: number) => setSearchFilters({
                                                    ...searchFilters, year: year
                                                })}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} className={"d-flex flex-column"}>
                                        <div className="mt-auto">
                                            <Button
                                                className={"purple-btn btn btn-primary"}
                                                onClick={() => reportQuery.refetch()}
                                                disabled={reportQuery.isRefetching || reportQuery.isLoading}
                                            >
                                                {
                                                    reportQuery.isRefetching || reportQuery.isLoading ? 'Exportando ...' : 'Exportar'
                                                }
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Row>

                </Col>
            </DefaultContainer>
        </RequireAuth>
    )
}

